<!-- <div class="text-danger" *ngIf="control?.touched && control?.invalid">
    <small *ngFor="let error of errorMessages">
      {{ error }}
    </small>
  </div> -->

<span class="error-icon" *ngIf="hasErrors" ngbTooltip="{{ errorMessages.join(', ') }}">
  <i class="bi bi-exclamation-circle-fill text-danger"></i>
</span>